export default "__VITE_ASSET__CORTDC$4__"